import { Button } from "@tblabs/truffle";


export class DangerButton extends Button
{
    constructor(label: string, action?: (self: DangerButton) => void)
    {
        super(label, action);
        this.DisplayInlineBlock();
        this.Class("uk-button uk-button-danger").Style("white-space: nowrap");
    }
}
